import React from 'react';
import PropTypes from 'prop-types';

import { Label } from '@sopranodesign/pulse-components';
import { TemplatingTextArea } from '@sopranodesign/pulse-templating';

import { useComposer } from '../../../../hooks/index';

const EventInput = ({
  rtl = 'ltr'
}) => {
  const {
    response: { content },
    dispatch
  } = useComposer();

  const handleResponseChange = value => {
    dispatch({ type: 'UPDATE_CONTENT', newContent: { text: value } });
  };

  return (
    <div>
      <Label htmlFor="event">Message</Label>
      <TemplatingTextArea
        rtl={rtl}
        id="event"
        name="event"
        value={content.text}
        onChange={handleResponseChange}
      />
    </div>
  );
};

EventInput.propTypes = {
  rtl: PropTypes.oneOf(['rtl', 'ltr'])
};

export default EventInput;
